export const GET_TUTOR_STATS = 'dashboard/GET_TUTOR_STATS'
export const GET_STUDENT_STATS = 'dashboard/GET_STUDENT_STATS'
export const GET_MAP = 'dashboard/GET_MAP'
export const GET_STUDENT_CALENDAR = 'dashboard/GET_STUDENT_CALENDAR'
export const GET_TUTOR_PAST_CLASSES = 'dashboard/GET_TUTOR_PAST_CLASSES'
export const GET_STUDENT_PAST_CLASSES = 'dashboard/GET_STUDENT_PAST_CLASSES'
export const GET_STUDENT_UPCOMING_CLASSES = 'dashboard/GET_STUDENT_UPCOMING_CLASSES'
export const GET_TUTOR_UPCOMING_CLASSES = 'dashboard/GET_TUTOR_UPCOMING_CLASSES'
